import { useState, useEffect } from "react";
import {
  setUnSavedCallSheet,
  useCallSheetState,
} from "../../../hooks/callSheet";
import "./index.scss";

function TimeTool(props: any) {
  const { size, updateTime, time, disabled, onClickInput } = props;
  const today = new Date();
  const callSheetState = useCallSheetState();
  const unsavedFlag = callSheetState.unsaved.get();
  const currentDate = today.toLocaleString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  const hrsStr = currentDate.split(":");
  const minStr = hrsStr[1].split(" ");
  const [hour, setHour] = useState<string>(hrsStr[0]);
  const [mins, setMin] = useState<string>(minStr[0]);
  const [amPm, setAmPm] = useState<string>(minStr[1]);

  const handleHours = (event: React.ChangeEvent<HTMLInputElement>) => {
    const number = event.target.value;
    if (Number(number) <= 12) {
      setHour(number);
      if (number && updateTime) updateTime({ hour: number, mins, amPm });
    }
  };
  const handleMin = (event: React.ChangeEvent<HTMLInputElement>) => {
    const number = event.target.value;
    if (Number(number) <= 59) {
      setMin(number);
      if (number && updateTime) updateTime({ hour, mins: number, amPm });
    }
  };
  const handleTime = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const ampm = event.target.value;
    if (updateTime) updateTime({ hour, mins, amPm: ampm });
    setAmPm(ampm);
  };

  useEffect(() => {
    if (updateTime) updateTime({ hour, mins, amPm });
    setUnSavedCallSheet(false);
  }, []);

  useEffect(() => {
    if (time && time !== "") {
      const hrsStr = time.split(":");
      const minStr = hrsStr[1].split(" ");
      setHour(hrsStr[0]);
      setMin(minStr[0]);
      setAmPm(minStr[1]);
    }
  }, [time]);

  return (
    <div className="time-tool">
      <input
        type="text"
        className={`input-${size}`}
        maxLength={2}
        value={hour}
        onChange={handleHours}
        onClick={onClickInput}
        disabled={disabled}
      />
      <span>:</span>
      <input
        className={`input-${size}`}
        type="text"
        maxLength={2}
        value={mins}
        onChange={handleMin}
        onClick={onClickInput}
        disabled={disabled}
      />
      <select
        className={`time-tool-zone select-${size}`}
        name="time"
        value={amPm}
        onChange={handleTime}
        onClick={onClickInput}
        disabled={disabled}
      >
        <option value="AM">AM</option>
        <option value="PM">PM</option>
      </select>
    </div>
  );
}
export default TimeTool;
